import { getCookie, deleteCookies } from './modules/Cookies';

if (getCookie('hbd-cookie-changed')) {
    deleteCookies(['hbd-cookie-settings']);
    location.reload();
}